import { getReadableTextColor } from '@utils/color.utils.js';

import './contraints-legend.css';

function ContraintsLegend({ legends, layerOpacities, onOpacityChange }) {
  return (
    <div className="contraints-legend__content" aria-label="Legenda inputlagen">
      {legends.map(legend => (
        <section className="contraints-legend__item" key={legend.layerId}>
          <h2 className="contraints-legend__title">{legend.label}</h2>
          {legend.colors && (
            <div className="contraints-legend__values">
              {legend.colors.map((color, index) => (
                <span
                  className="contraints-legend__value"
                  key={`${legend.layerId}-${index}`}
                  style={{
                    backgroundColor: color,
                    color: getReadableTextColor(color),
                  }}
                >
                  {index}
                </span>
              ))}
            </div>
          )}
          <label className="contraints-legend__opacity">
            <span>Transparantie</span>
            <input
              max="1"
              min="0"
              onChange={event => onOpacityChange(
                legend.opacityLayerIds || [legend.layerId],
                event.target.value,
              )}
              step="0.01"
              type="range"
              value={layerOpacities[legend.opacityLayerIds?.[0] || legend.layerId]}
            />
          </label>
        </section>
      ))}
    </div>
  );
}

export default ContraintsLegend;
